<p-toast styleClass="ip-auth-toast"></p-toast>
<div class="auth-root">
  <!-- Left: Branded Role Panel -->
  <div class="auth-panel" [ngClass]="currentRole.accentClass">
    <div class="auth-panel-inner">
      <!-- Logo row: logo left, role badge right -->
      <div class="auth-panel-logo-row">
        <img src="/images/interpanely_logo_light.png" alt="Interpanely" class="auth-logo-img" />
        <span class="auth-panel-role-badge">{{ currentRole.displayName }}</span>
      </div>

      <!-- Tagline + description -->
      <div class="auth-panel-content">
        <h1 class="auth-panel-tagline">{{ currentRole.tagline }}</h1>
        <p class="auth-panel-desc">{{ currentRole.description }}</p>
      </div>

      <!-- Role switcher dots -->
      <div class="auth-panel-dots">
        <span
          class="auth-panel-dot"
          [class.active]="role() === 'candidate'"
          (click)="role.set('candidate')"
        ></span>
        <span
          class="auth-panel-dot"
          [class.active]="role() === 'panel'"
          (click)="role.set('panel')"
        ></span>
        <span
          class="auth-panel-dot"
          [class.active]="role() === 'corporates'"
          (click)="role.set('corporates')"
        ></span>
      </div>
    </div>
  </div>

  <!-- Right: Form Panel -->
  <div class="auth-form-panel">
    <!-- Top bar with theme toggle -->
    <div class="auth-form-topbar">
      <button
        class="auth-theme-toggle"
        (click)="toggleTheme()"
        [title]="isDark() ? 'Switch to light mode' : 'Switch to dark mode'"
      >
        <i class="pi" [ngClass]="isDark() ? 'pi-sun' : 'pi-moon'"></i>
      </button>
    </div>

    <!-- Centered form area -->
    <div class="auth-form-center">
      <div class="auth-form-wrap">
        <div class="auth-form-header">
          <h2 class="auth-form-title">Welcome back</h2>
          <p class="auth-form-subtitle">
            Sign in to your <strong>{{ currentRole.displayName }}</strong> account
          </p>
        </div>

        <!-- Error -->
        @if (errorMsg()) {
          <div class="auth-error">
            <i class="pi pi-exclamation-circle"></i>
            <span>{{ errorMsg() }}</span>
          </div>
        }

        <form (ngSubmit)="onLogin()" autocomplete="on">
          <!-- Email -->
          <div class="auth-field">
            <label class="auth-label" for="login-email"
              >Email address <span class="auth-required">*</span></label
            >
            <input
              id="login-email"
              type="email"
              pInputText
              [(ngModel)]="email"
              name="email"
              [placeholder]="emailPlaceholder"
              autocomplete="email"
              class="auth-input"
            />
          </div>

          <!-- Password -->
          <div class="auth-field">
            <div class="auth-label-row">
              <label class="auth-label" for="login-password"
                >Password <span class="auth-required">*</span></label
              >
              <a class="auth-link auth-link--sm" (click)="forgotPassword()">Forgot password?</a>
            </div>
            <div class="auth-input-wrap">
              <input
                id="login-password"
                [type]="showPassword() ? 'text' : 'password'"
                pInputText
                [(ngModel)]="password"
                name="password"
                placeholder="Enter your password"
                autocomplete="current-password"
                class="auth-input auth-input--with-toggle"
              />
              <i
                class="pi auth-password-toggle"
                [ngClass]="showPassword() ? 'pi-eye-slash' : 'pi-eye'"
                (click)="togglePassword()"
              ></i>
            </div>
          </div>

          <!-- Submit -->
          <button
            type="submit"
            pButton
            pRipple
            [disabled]="loading() || !email || !password"
            class="auth-submit-btn"
          >
            @if (loading()) {
              <i class="pi pi-spin pi-spinner"></i>
            }
            <span>{{ loading() ? 'Signing in…' : 'Sign In' }}</span>
          </button>
        </form>

        <!-- Social Federation - candidate only -->
        @if (role() === 'candidate') {
          <div class="auth-divider">
            <span>or continue with</span>
          </div>
          <div class="auth-social-btns">
            <button
              class="auth-social-btn auth-social-btn--google"
              (click)="loginWithGoogle()"
              pRipple
            >
              <i class="pi pi-google"></i>
              <span>Google</span>
            </button>
          </div>
        }

        <!-- Phone OTP login, available for candidate, panelist, and corporate -->
        @if (role() !== 'candidate') {
          <div class="auth-divider">
            <span>or continue with</span>
          </div>
        }
        <button
          type="button"
          class="auth-social-btn auth-phone-otp-btn"
          (click)="goToPhoneLogin()"
          pRipple
        >
          <i class="pi pi-mobile"></i>
          <span>Login with Phone OTP</span>
        </button>

        <!-- Footer -->
        <p class="auth-footer-text">
          Don't have an account?
          <a class="auth-link" (click)="goToRegister()">Create one</a>
        </p>
      </div>
    </div>
  </div>
</div>
